import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import VirtualDrapeTestScreen from '../virtual-drape/VirtualDrapeTestScreen';
import PublicPageHeader from '../../components/landing/PublicPageHeader';

/**
 * Public Virtual Drape - public screen for unauthenticated users.
 * Separate from authenticated VirtualDrapeTestScreen for security isolation.
 * Same implementation (1 try, blurred results, sign-up redirect).
 */
const PublicVirtualDrapeScreen = () => {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <PublicPageHeader activeScreen="virtual-drape" />
      <VirtualDrapeTestScreen isPublicPreview={true} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default PublicVirtualDrapeScreen;
